// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let ContentBox__Jsx3 = require("../../../uikit/reason/atoms/ContentBox/ContentBox__Jsx3.bs.js");
let JsxRuntime = require("react/jsx-runtime");

function ErrorComponent(props) {
  return JsxRuntime.jsx(ContentBox__Jsx3.make, {
    paddingFull: true,
    hasShadow: true,
    children: props.message
  });
}

function ErrorComponent$Large(props) {
  return JsxRuntime.jsx("div", {
    children: props.children,
    className: "text-center leading-normal text-base sm:text-lg md:text-xl"
  });
}

let Large = {
  make: ErrorComponent$Large
};

let make = ErrorComponent;

exports.make = make;
exports.Large = Large;
/* ContentBox__Jsx3 Not a pure module */
